export default "__VITE_ASSET__0fa84180__"